// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Question_wrapper__N4tU3","theme":"Question_theme__U6FVm","question":"Question_question__2SexH","title":"Question_title__3Gfud","textarea":"Question_textarea__8daxk"};